import React, { useState, useEffect } from 'react'
import { Box, Flex, Group, Button, Paper, Image, Text, NumberFormatter, Divider, ScrollArea, Table, NumberInput, ActionIcon, ThemeIcon } from '@mantine/core'
import { getDetailProduct } from '../../../../../services/products'
import { addOrderProductItems } from '../../../../../services/orders'
import { calculation } from '../../../../../services/calculation'
import { useNavigate, useParams } from 'react-router-dom'
import LoadingData from '../../../../ui/LoadingData'
import NoImage from '../../../../../assets/img/images/no-images.png'
import { IconPlus, IconMinus, IconCircleCheckFilled } from '@tabler/icons-react'
import { notificationError, loadingNotification, completedLoadingNotification } from '../../../../ui/Notifications'
import { getOrderDetail } from '../../../../../store/orderDetail'
import { useDispatch } from 'react-redux'
import { modals } from '@mantine/modals'

const labelTableVariant = [
  {
    label: 'Image',
    width: 10
  },
  {
    label: 'Specification',
    width: 800
  },
  {
    label: 'Stock',
    width: 100
  },
  {
    label: 'Price',
    width: 200
  },
]

const FormDetailProductCatalog = ({ recentDataProduct, onCloseModal, reloadList }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const params = useParams()
  const orderId = params.order_id
  const orderCurrency = params.order_currency
  const [loading, setLoading] = useState(true)
  const [loadingForm, setLoadingForm] = useState(false)
  const [convertDetailProduct, setConvertDetailProduct] = useState(null)
  const [selectedVariantProduct, setSelectedVariantProduct] = useState(null)
  const [qtyProduct, setQtyProduct] = useState(0)

  const submitAddProductOrder = async () => {
    setLoadingForm(true)
    if (qtyProduct === 0 || qtyProduct === '') {
      notificationError(`Add Product to Order ID ${orderId}`, 'You must input quantity product')
      setLoadingForm(false)
      return
    }
    const payload = {
      items: []
    }

    const findDataTaxes = (data, valueTax) => {
      const dataTax = data
      const findDataTax = dataTax.find((val) => val.label === valueTax)
      return findDataTax.value
    }

    if (selectedVariantProduct === null) {
      const payloadItems = {
        product_id: convertDetailProduct.id,
        base_unit_name: convertDetailProduct.quantity_unit,
        cost: convertDetailProduct.regular_price,
        currency: orderCurrency,
        image_url: convertDetailProduct.image,
        original_name: convertDetailProduct.original_title,
        original_price: convertDetailProduct.regular_price,
        price: convertDetailProduct.regular_price,
        product_name: convertDetailProduct.title,
        quantity: qtyProduct,
        quantity_per_unit: convertDetailProduct.minimum_qty,
        unit_name: convertDetailProduct.quantity_unit,
        variants: convertDetailProduct.variants,
        weight: convertDetailProduct.weight,
        sku_status: {
          id: 22,
        },
        rule: {
          weight_unit: convertDetailProduct.rules.category_rule.attributes.weight_unit,
          total_weight: 0,
          total_tax: 0,
          qty_cbm: convertDetailProduct.rules.category_rule.attributes.qty_cbm,
          hscodes: '87150000',
          taxes: [
            {
              label: 'BM',
              value: findDataTaxes(convertDetailProduct.rules.category_rule.attributes.quick_tax_details, 'BM')
            },
            {
              label: 'PPN',
              value: findDataTaxes(convertDetailProduct.rules.category_rule.attributes.quick_tax_details, 'PPN')
            },
            {
              label: 'PPH',
              value: findDataTaxes(convertDetailProduct.rules.category_rule.attributes.quick_tax_details, 'PPH')
            },
          ],
          weight: convertDetailProduct.rules.category_rule.attributes.weight
        },
      }
      payload.items.push(payloadItems)
    } else {
      const payloadItems = {
        product_id: convertDetailProduct.id,
        base_unit_name: convertDetailProduct.quantity_unit,
        cost: selectedVariantProduct.attributes.regular_price,
        currency: orderCurrency,
        image_url: selectedVariantProduct.attributes.image_url,
        original_name: convertDetailProduct.original_title,
        original_price: selectedVariantProduct.attributes.regular_price,
        price: selectedVariantProduct.attributes.regular_price,
        product_name: convertDetailProduct.title,
        quantity: qtyProduct,
        quantity_per_unit: selectedVariantProduct.attributes.minimum_qty,
        unit_name: convertDetailProduct.quantity_unit,
        variants: selectedVariantProduct.attributes.options_values.length > 0 ? selectedVariantProduct.attributes.options_values : convertDetailProduct.variants,
        weight: convertDetailProduct.weight,
        sku_status: {
          id: 22,
        },
        rule: {
          weight_unit: convertDetailProduct.rules.category_rule.attributes.weight_unit,
          total_weight: 0,
          total_tax: 0,
          qty_cbm: convertDetailProduct.rules.category_rule.attributes.qty_cbm,
          hscodes: null,
          taxes: [
            {
              label: 'BM',
              value: findDataTaxes(convertDetailProduct.rules.category_rule.attributes.quick_tax_details, 'BM')
            },
            {
              label: 'PPN',
              value: findDataTaxes(convertDetailProduct.rules.category_rule.attributes.quick_tax_details, 'PPN')
            },
            {
              label: 'PPH',
              value: findDataTaxes(convertDetailProduct.rules.category_rule.attributes.quick_tax_details, 'PPH')
            },
          ],
          weight: convertDetailProduct.rules.category_rule.attributes.weight
        },
      }
      payload.items.push(payloadItems)
    }
    try {
      const response = await addOrderProductItems(orderId, payload)
      if (response.success) {
        const loadingCalculation = loadingNotification('Waiting Calculation Order', 'Please Wait. . .')
        const responseCalculation = await calculation(orderId)
        if (responseCalculation.success) {
          dispatch(getOrderDetail(orderId))
          completedLoadingNotification(loadingCalculation, 'Calculation Order Successfully', 'This order has been completed in calculation')
          modalProductOrderSuccess(convertDetailProduct)
        }
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      notificationError('Update Order Error', `${errorMessage ? errorMessage : 'Please contact your administrator'}`)
    } finally {
      setLoadingForm(false)
    }
  }

  const handleGetDetailProduct = async (productId, orderCurrency) => {
    setLoading(true)
    const params = {
      convert_to: orderCurrency,
      include: 'variations,bulk_prices',
    }
    try {
      const response = await getDetailProduct(productId, params)
      if (response.success) {
        const dataProduct = response.data
        const variantProduct = Object.values(response.included.variations)
        const bundleProduct = Object.values(response.included.bulk_prices)

        const remapDataProduct = {
          ...dataProduct.attributes,
          variants: [{
            name: 'Product Name',
            option: recentDataProduct.title,
          }], 
          variations: variantProduct,
          bundle: bundleProduct
        }
        setConvertDetailProduct(remapDataProduct)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (recentDataProduct) {
      handleGetDetailProduct(recentDataProduct.id, orderCurrency)
    }
    // eslint-disable-next-line
  }, [recentDataProduct])

  const modalProductOrderSuccess = (dataProduct) => modals.open({
    centered: true,
    withCloseButton: false,
    size: 'lg',
    radius: 'md',
    children: (
      <Box>
        <Box ta='center' my={14}>
          <Flex justify='center'>
            <ThemeIcon variant="white" size={200} color='green'>
              <IconCircleCheckFilled style={{ width: '100%', height: '100%' }} />
            </ThemeIcon>
          </Flex>
          <Text fz={16} fw='600'>Successfully Added Product to Order</Text>
          <Text fz={12} fw='500' c='dimmed'>"{dataProduct.title}"</Text>
        </Box>
        
        <Box mt={40}>
          <Button fullWidth  size='xs' onClick={() => [modals.closeAll(), onCloseModal(), reloadList()]}>Add Product Again</Button>
          <Button fullWidth variant='outline' size='xs' onClick={() => [modals.closeAll(), navigate(`/order/${orderId}`)]} mt="sm">Go to Detail Order</Button>
        </Box>
      </Box>
    )
  })

  const handleDisabledButtonAdd = (selectedVariant, convertedProduct) => {
    if (selectedVariant !== null) {
      if (!Math.sign(selectedVariant.attributes.quantity - qtyProduct) || selectedVariantProduct.attributes.quantity === 0) {
        return true
      }
    } else {
      if (!Math.sign(convertedProduct.quantity - qtyProduct) || convertedProduct.quantity === 0) {
        return true
      }
    }
    return false
  }

  const decreaseQty = () => {
    if (qtyProduct <= 0) {
      setQtyProduct(0)
    } else {
      setQtyProduct(qtyProduct - 1)
    }
  }

  const increaseQty = () => {
    let maxQty = 0
    if (selectedVariantProduct !== null) {
      maxQty = selectedVariantProduct.attributes.quantity
    } else {
      maxQty = convertDetailProduct.quantity
    }
    if (qtyProduct >= maxQty) {
      setQtyProduct(maxQty)
    } else {
      setQtyProduct(qtyProduct + 1)
    }
  };

  const mappingTableVariant = (convertedProduct) => {
    if (convertedProduct.variations.length > 0) {

      const mappingDataVariant = (label, dataVariant) => {
        const mappingTableHead = (data) => data.map((val, index) => {
          return (<Table.Th key={index} width={val.width !== 'auto' ? val.width : ''}>{val.label}</Table.Th>)
        })

        const mappingDataTable = (data) => {
          const mappingValueVariants = (dataValueVariants) => {
            if (dataValueVariants.length > 0) {
              const remapValue = dataValueVariants.map((val, index) => {
                return (<Text fw='bold' fz={11} key={index} tt='capitalize'>{val.name}: <Text component='span' fz={11} fw={500}>{val.option}</Text></Text>)
              })
              return (
                <Box>
                  {remapValue}
                </Box>
              )
            }
            
          }
          const remapDataTableVariant = data.map((val, index) => {
            return (
              <Table.Tr key={index} onClick={() => setSelectedVariantProduct(val)} style={{ cursor: 'pointer', backgroundColor: selectedVariantProduct !== null ? val.id === selectedVariantProduct.id ? '#dee2e6' : '' : '' }}>
                <Table.Td>
                  <Paper shadow="sm" w={52} withBorder radius='md' style={{ cursor: 'pointer' }}>
                    <Image w={50} h={50} radius='md' src={val.attributes.image_url !== null ? val.attributes.image_url : NoImage} />
                  </Paper>
                </Table.Td>
                <Table.Td>
                  {mappingValueVariants(val.attributes.options_values)}
                </Table.Td>
                <Table.Td>
                  {val.attributes.quantity}
                </Table.Td>
                <Table.Td>
                  <NumberFormatter prefix={`${orderCurrency} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={val.attributes.regular_price} />
                </Table.Td>
              </Table.Tr>
            )
          })
          return remapDataTableVariant
        }

        return (
          <Table.ScrollContainer type='native'>
            <Table verticalSpacing="xs" highlightOnHover withTableBorder style={{ fontSize: '13px' }}>
              <Table.Thead style={{ backgroundColor: '#eeefef' }}>
                <Table.Tr>
                  {mappingTableHead(label)}
                </Table.Tr>
              </Table.Thead>
              <Table.Tbody style={{ verticalAlign: 'top' }}>
                {mappingDataTable(dataVariant)}
              </Table.Tbody>
            </Table>
          </Table.ScrollContainer>
        )
      }
      
      return (
        <Box my={10}>
          <Divider size='xs' my='xs' />
          <Box mx={4}>
            <Text fz={16} fw={600}>Variants Product</Text>
            <Box my={20}>
              <ScrollArea h={250} type="auto" offsetScrollbars overscrollBehavior="none" scrollbarSize={4} scrollbars="y">
                {mappingDataVariant(labelTableVariant, convertedProduct.variations)}
              </ScrollArea>
            </Box>
          </Box>
        </Box>
      )
    }
  }

  const mappingDetailProduct = (convertedProduct) => {

    const mappingSelectedVariant = (selectedVariant) => {
      if (selectedVariant !== null) {
        const dataVariant = selectedVariant.attributes.options_values
        if (dataVariant) {
          const remapDataVariant = dataVariant.map((val, index) => {
            return (
              <Text component='span' fz={11} fw='bold' key={index} tt='capitalize'>{val.name}: <Text component='span' fz={11} fw={500}>{val.option}</Text> {index !== Object.keys(dataVariant).length - 1 ? ',' : ''}</Text>
            )
          })
          return (
            <Box>
              {remapDataVariant}
            </Box>
          )
        } 
      }
    }

    const mappingSelectedPriceVariant = (selectedVariant, convertedProduct) => {
      return (
        <Text fz={18} fw='bold' c='red' mb={4}>
          <NumberFormatter prefix={`${orderCurrency} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={selectedVariant === null ? convertedProduct.regular_price : selectedVariant.attributes.regular_price} />
        </Text>
      )
    }

    const handleSetFormQtyProduct = () => {
      return (
        <Flex gap='md' align='center'>
          <Group gap='xs' align='center'>
            <ActionIcon 
              variant="filled"
              color="red"
              size="md"
              radius='xl'
              onClick={() => decreaseQty()}
              disabled={qtyProduct === 0}
            >
              <IconMinus style={{ width: '70%', height: '70%' }} stroke={1.5} />
            </ActionIcon>
            <NumberInput
              value={qtyProduct}
              min={0}
              size='xs'
              onChange={(val) => setQtyProduct(val)}
            />
            <ActionIcon 
              variant="filled"
              color="red"
              size="md"
              radius='xl'
              onClick={() => increaseQty()}
              disabled={selectedVariantProduct !== null ? (selectedVariantProduct.attributes.quantity - qtyProduct) <= 0 : (convertDetailProduct.quantity - qtyProduct) <= 0}
            >
              <IconPlus style={{ width: '70%', height: '70%' }} stroke={1.5} />
            </ActionIcon>
          </Group>
          <Box>
            <Text fz={14} fw={500} c='gray' tt='capitalize'>Stock: {selectedVariantProduct !== null ? (selectedVariantProduct.attributes.quantity - qtyProduct) :(convertDetailProduct.quantity - qtyProduct)} {convertDetailProduct.quantity_unit}</Text>
          </Box>
        </Flex>
      )
    }
    return (
      <Box>
        <Flex gap='sm' align='start'>
          <Paper shadow="sm" w={102} withBorder radius='md'>
            <Image w={100} h={100} radius='md' src={recentDataProduct.image !== null ? recentDataProduct.image : NoImage} />
          </Paper>
          <Box style={{ flex: '0 0 80%' }}>
            <Box>
              <Text fz={14} fw={600} lineClamp={2} h={40} mt={2}>{recentDataProduct.title}</Text>
              <Box h={20}>
                {mappingSelectedVariant(selectedVariantProduct)}
              </Box>
            </Box>
          </Box>
        </Flex>
        <Box>
          {mappingTableVariant(convertDetailProduct)}
        </Box>
        <Box mt={20}>
          <Flex justify='space-between' align='flex-end'>
            <Box>
              {mappingSelectedPriceVariant(selectedVariantProduct, convertDetailProduct)}
              {handleSetFormQtyProduct()}
            </Box>
            <Group>
              <Button size='xs' variant="outline" onClick={onCloseModal}>Close</Button>
              <Button size='xs' variant="filled" loading={loadingForm} disabled={handleDisabledButtonAdd(selectedVariantProduct, convertDetailProduct)} onClick={() => submitAddProductOrder()}>Add Now</Button>
            </Group>
          </Flex>
        </Box>
      </Box>
    )
  }

  if (recentDataProduct !== null) {
    return (
      <Box>
        <Box>
          {loading ? <LoadingData /> : mappingDetailProduct(convertDetailProduct)}
        </Box>
      </Box>
    )
  }
  
}

export default FormDetailProductCatalog